<template>
	<header
		class="relative sm:fixed top-0 -mt-[75px] sm:mt-0 z-40 w-full bg-white sm:transition-shadow duration-1000 ease-in-out"
		:class="dropshadow"
	>
		<ResponsiveContainer class="flex items-center justify-end sm:justify-between h-[50px] sm:h-[75px] px-2">
			<div class="sm:min-w-[152px]">
				<button @click="$router.go(-1)" type="grey" class="flex items-center text-sm">
					<span class="hidden sm:flex w-[24px] material-icons-outlined pr-2 text-base">arrow_backward</span>
					<span class="hidden sm:flex">{{ $t("back") }}</span>
					<BaseIcon class="sm:hidden" :width="36" :height="36" icon="ic:round-close" />
				</button>
			</div>
			<NuxtLink class="hidden sm:flex md:max-w-[235px] mx-2" :to="`/${$i18n.locale}`">
				<DjLogo v-if="region != ''" :region="region" />
			</NuxtLink>
			<div class="hidden sm:flex">
				<slot />
			</div>
		</ResponsiveContainer>
	</header>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
	name: "StickyHeaderSimple",
	setup() {
		const dropshadow = ref("");
		const region = ref("");

		function handleScroll() {
			let scrollPosition = window.scrollY;
			scrollPosition > 0 ? (dropshadow.value = "sm:drop-shadow-md") : (dropshadow.value = "sm:drop-shadow-none");
		}

		onMounted(() => {
			window.addEventListener("scroll", handleScroll);
			region.value = useRegion.getCurrentRegion().code;
		});

		return {
			dropshadow,
			region,
		};
	},
});
</script>
